module.exports = __webpack_public_path__ + "static/media/wrong-choice.67c7dbb8.wav";